module.exports = __webpack_public_path__ + "img/logo.ab6cd437.png";